import { render, staticRenderFns } from "./PasswordResetFailure.vue?vue&type=template&id=131ed67e&scoped=true&"
import script from "./PasswordResetFailure.vue?vue&type=script&lang=js&"
export * from "./PasswordResetFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ed67e",
  null
  
)

export default component.exports